/**
 * DOG OWNED — quantity steppers.
 *
 * The number input works on its own; these buttons are enhancement. They ship
 * with the `hidden` attribute and are only revealed here, so they are never
 * dead controls for a customer without JavaScript.
 *
 * Shared by the product form and every cart line.
 */
(function () {
  'use strict';

  function setup(root) {
    var input = root.querySelector('[data-qty-input]');
    if (!input) return;

    var buttons = root.querySelectorAll('[data-qty-step]');
    Array.prototype.forEach.call(buttons, function (button) {
      button.hidden = false;
      button.addEventListener('click', function () {
        var step = parseInt(button.getAttribute('data-qty-step'), 10);
        var min = parseInt(input.getAttribute('min'), 10);
        if (isNaN(min)) min = 0;
        var current = parseInt(input.value, 10);
        if (isNaN(current)) current = min;
        var next = current + step;
        if (next < min) next = min;
        if (String(next) === String(current)) return;
        input.value = next;
        // Let listeners (cart auto-submit) react as if a human typed it.
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-qty]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
